module.exports = __webpack_public_path__ + "img/e37726b.jpg";